import { COLOR } from '../data/colors.data'
import { Appointment } from '../model/appointment'

export enum FRONTEND_ELIGIBILITY_STATUS {
  CONNECTIVITY_ISSUES = 'connectivity-issues',
  COVERAGE_MISMATCH = 'coverage-mismatch',
  ACTIVE = 'active',
  USER_INTERVENTION = 'user-intervention',
  STATUS_MISMATCH = 'status-mismatch',
}

export function getFrontendEligibilityStatus(status: Appointment.ELIGIBILITY_STATUS): FRONTEND_ELIGIBILITY_STATUS {
  switch (status) {
    case Appointment.ELIGIBILITY_STATUS.SOFT_FAIL:
    case Appointment.ELIGIBILITY_STATUS.HARD_FAIL:
      return FRONTEND_ELIGIBILITY_STATUS.CONNECTIVITY_ISSUES
    case Appointment.ELIGIBILITY_STATUS.INVALID:
    case Appointment.ELIGIBILITY_STATUS.INACTIVE:
      return FRONTEND_ELIGIBILITY_STATUS.COVERAGE_MISMATCH
    case Appointment.ELIGIBILITY_STATUS.ACTIVE:
    case Appointment.ELIGIBILITY_STATUS.NOT_REQUIRED:
      return FRONTEND_ELIGIBILITY_STATUS.ACTIVE
    case Appointment.ELIGIBILITY_STATUS.NONE:
    case Appointment.ELIGIBILITY_STATUS.NO_CONNECTION:
      return FRONTEND_ELIGIBILITY_STATUS.USER_INTERVENTION
    case Appointment.ELIGIBILITY_STATUS.MISMATCH:
      return FRONTEND_ELIGIBILITY_STATUS.STATUS_MISMATCH
    default:
      return FRONTEND_ELIGIBILITY_STATUS.USER_INTERVENTION
  }
}

export function getBackendStatuses(frontendStatus: FRONTEND_ELIGIBILITY_STATUS): Appointment.ELIGIBILITY_STATUS[] {
  switch (frontendStatus) {
    case FRONTEND_ELIGIBILITY_STATUS.CONNECTIVITY_ISSUES:
      return [Appointment.ELIGIBILITY_STATUS.SOFT_FAIL, Appointment.ELIGIBILITY_STATUS.HARD_FAIL]
    case FRONTEND_ELIGIBILITY_STATUS.COVERAGE_MISMATCH:
      return [Appointment.ELIGIBILITY_STATUS.INVALID, Appointment.ELIGIBILITY_STATUS.INACTIVE]
    case FRONTEND_ELIGIBILITY_STATUS.ACTIVE:
      return [Appointment.ELIGIBILITY_STATUS.ACTIVE, Appointment.ELIGIBILITY_STATUS.NOT_REQUIRED]
    case FRONTEND_ELIGIBILITY_STATUS.USER_INTERVENTION:
      return [Appointment.ELIGIBILITY_STATUS.NONE, Appointment.ELIGIBILITY_STATUS.NO_CONNECTION]
    case FRONTEND_ELIGIBILITY_STATUS.STATUS_MISMATCH:
      return [Appointment.ELIGIBILITY_STATUS.MISMATCH]
    default:
      return []
  }
}

export function eligibilityGroupColor(group: FRONTEND_ELIGIBILITY_STATUS): COLOR {
  switch (group) {
    case FRONTEND_ELIGIBILITY_STATUS.ACTIVE:
      return COLOR.GREEN
    case FRONTEND_ELIGIBILITY_STATUS.COVERAGE_MISMATCH:
      return COLOR.YELLOW
    case FRONTEND_ELIGIBILITY_STATUS.STATUS_MISMATCH:
      return COLOR.RED
    case FRONTEND_ELIGIBILITY_STATUS.CONNECTIVITY_ISSUES:
    case FRONTEND_ELIGIBILITY_STATUS.USER_INTERVENTION:
      return COLOR.BLACK
    default:
      return COLOR.BLACK
  }
}

export function eligibilityGroupIcon(group: FRONTEND_ELIGIBILITY_STATUS): string {
  switch (group) {
    case FRONTEND_ELIGIBILITY_STATUS.ACTIVE:
      return 'gpp_good'
    case FRONTEND_ELIGIBILITY_STATUS.COVERAGE_MISMATCH:
      return 'gpp_bad'
    case FRONTEND_ELIGIBILITY_STATUS.STATUS_MISMATCH:
    case FRONTEND_ELIGIBILITY_STATUS.CONNECTIVITY_ISSUES:
    case FRONTEND_ELIGIBILITY_STATUS.USER_INTERVENTION:
      return 'shield'
    default:
      return 'shield'
  }
}

export function eligibilityStatusIcon(status: Appointment.ELIGIBILITY_STATUS): string {
  switch (status) {
    case Appointment.ELIGIBILITY_STATUS.ACTIVE:
    case Appointment.ELIGIBILITY_STATUS.NOT_REQUIRED:
      return 'gpp_good'
    case Appointment.ELIGIBILITY_STATUS.INACTIVE:
    case Appointment.ELIGIBILITY_STATUS.INVALID:
      return 'gpp_bad'
    default:
      return 'shield'
  }
}
